import React from 'react';
import { Icon } from '../icon/Icon';
import './Tag.scss';

interface TagProps {
  type: 'mPerks' | 'specialOffer' | 'outOfStock' | 'holidaySpecial';
}

export const Tag: React.FC<TagProps> = ({ type }) => {
  return (
    <div className="ads-tag" data-testid="ads-tag">
      {type === 'mPerks' && (
        <span>
          <Icon name="coupons" color="ads-color-savings" />
          mPerks
        </span>
      )}

      {type === 'specialOffer' && (
        <span>
          <Icon name="offer" color="ads-color-savings" />
          Buy 1, Get 1 Free
        </span>
      )}

      {type === 'outOfStock' && (
        <span className="out-of-stock">Out of Stock</span>
      )}

      {type === 'holidaySpecial' && (
        <span
          className="holiday-special"
          data-testid="ads-tag__holiday-special"
        >
          <Icon name="tipsRatings" color="ads-color-support-success" />
          Holiday Special
        </span>
      )}
    </div>
  );
};
